<div class="td-wb-typeahead-container"
     cdk-overlay-origin
     #connectedOverlayOrigin="cdkOverlayOrigin"
     role="combobox"
     [attr.aria-label]="ariaLabel()"
     [attr.aria-expanded]="isOpen()"
     [attr.aria-owns]="isOpen() ? 'td-wb-typeahead-panel' : undefined"
     [attr.aria-controls]="isOpen() ? 'td-wb-typeahead-panel' : undefined"
     aria-haspopup="listbox">
  <input #inputElement
         class="td-wb-typeahead-input"
         [id]="id()"
         [attr.placeholder]="placeholder()"
         [attr.disabled]="internalDisabled() ? '' : null"
         [attr.required]="required() ? '' : null"
         [attr.aria-autocomplete]="'list'"
         [attr.aria-activedescendant]="isOpen() && activeItem() ? activeItem().id : null"
         [value]="value()"
         (input)="onInputChange($event)"
         (keydown)="onKeyDown($event)"
         (focus)="onInputFocus($event)"
         (blur)="onInputBlur($event)">
</div>
@if (showVhOptions()) {
  <ul class="td-wb-vh" role="listbox">
    @for (item of items(); track item; let i = $index) {
      <li>
        <button [id]="'td-wb-typeahead-vh-' + i"
                [innerText]="item.getLabel()"
                (keydown)="item.onKeyDown()"
                (click)="item.onClick()">
        </button>
      </li>
    }
  </ul>
}
<ng-template
  cdkConnectedOverlay
  cdkConnectedOverlayLockPosition
  cdkConnectedOverlayHasBackdrop
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  [cdkConnectedOverlayOpen]="isOpen()"
  [cdkConnectedOverlayOrigin]="overrideOverlayOrigin() ?? connectedOverlayOrigin"
  [cdkConnectedOverlayMinWidth]="toggleRect()?.width"
  (positionChange)="onPositionChange($event)"
  (backdropClick)="close()"
  (attach)="onAttached()"
  (detach)="detach()">
  <div class="td-wb-typeahead__panel"
       [ngClass]="'td-wb-typeahead__panel--' + panelPosition()"
       id="td-wb-typeahead-panel"
       role="listbox"
       [attr.aria-hidden]="platformIOS()">
    <ng-content />
  </div>
</ng-template>
